import { Loader } from '@infura/packages.ui/Loader'

export const LoadingSkeleton = () => (
  <div className='bg-background-default mb-8 w-full'>
    <div className='w-full p-2'>
      <Loader className='h-12' pulse />
    </div>
    <div className='flex w-full flex-row'>
      <div className='w-1/4 p-2'>
        <Loader className='mb-4 h-12' pulse />
        <Loader className='mb-4 h-12' pulse />
        <Loader className='mb-4 h-12' pulse />
        <Loader className='mb-4 h-12' pulse />
      </div>
      <div className='flex w-3/4 flex-col'>
        <div className='flex w-full flex-row'>
          <div className='w-3/5 p-2'>
            <Loader className='h-72' pulse />
          </div>
          <div className='w-2/5 p-2'>
            <Loader className='h-72' pulse />
          </div>
        </div>

        <div className='w-24 p-2'>
          <Loader className='h-8' pulse />
        </div>
      </div>
    </div>
  </div>
)
